import {
  //   dangerColor,
  whiteColor,
  warningColor,
  lightBlueColor,
  primaryBoxShadow,
  grayColor
} from "assets/jss/material-dashboard-pro-react.js";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";

const IMAGE_WIDTH = "0px";

const menuStyle = theme => ({
  ...buttonStyle,
  title: {
    fontFamily: "'Archivo Narrow', sans-serif",
    fontSize: "20px",
    color: "#555555",
    fontWeight: "bold",
    marginTop: "10px"
  },
  containerMenu: {
    width: "100%",
    marginTop: "20px",
    // padding: "0 20px",
    display: "inline-block",
    overflow: "hidden",
    marginBottom: "5px",
    [theme.breakpoints.down("md")]: {
      marginBottom: "0px"
    }
  },
  containerCard: {
    [theme.breakpoints.down("md")]: {}
  },
  containerElement: {
    lineHeight: "30px",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      // lineHeight: "30px",
      position: "absolute",
      bottom: 0,
      // width: `calc(100% - 150px)`
      width: `calc(100% - ${IMAGE_WIDTH})`,
      paddingRight: "30px"
    }
  },
  image: {
    width: "100%",
    maxHeight: "370px",
    objectFit: "scale-down",
    [theme.breakpoints.up("sm")]: {
      width: IMAGE_WIDTH,
      height: IMAGE_WIDTH,
      float: "left"
    }
  },
  containerInfo: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${IMAGE_WIDTH})`,
      minHeight: IMAGE_WIDTH,
      paddingBottom: "50px"
    },
    padding: "10px",
    paddingBottom: "5px",
    width: "100%",
    float: "left"
  },
  containerLeft: {
    fontWeight: "normal",
    display: "inline-block",
    lineHeight: "60px",
    float: "left"
  },
  containerRight: {
    fontWeight: "normal",
    lineHeight: "60px",
    textAlign: "right",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    float: "right"
  },
  dishName: {
    fontSize: "18px",
    color: "#555555",
    fontFamily: "'Archivo Narrow', sans-serif",
    margin: 0
    // font-size: 17px;
    // float: "right",
  },
  description: {
    fontFamily: "'Archivo Narrow', sans-serif",
    fontSize: "15px",
    color: "##9b9b9b"
  },
  priceText: {
    fontSize: "20px",
    color: "#4a4a4a",
    fontFamily: "'Archivo Narrow', sans-serif",
    // font-size: 17px;
    fontWeight: "bold",
    textAlign: "right",
    fontStyle: "italic",
    // float: "right",
    lineHeight: "60px"
  },
  littlePrice: {
    fontSize: "13px",
    color: "white",
    fontFamily: "'Archivo Narrow', sans-serif",
    // font-size: 17px;
    // fontWeight: "bold",
    textAlign: "right"
    // float: "right",
  },
  buttonSmall: {
    width: "24px",
    height: "24px",
    bordeRadius: "12px",
    border: "solid 1px",
    borderColor: lightBlueColor,
    padding: "0px",
    marginTop: "0px"
  },
  buttonText: {
    fontSize: "20px",
    color: lightBlueColor,
    lineHeight: "20px"
  },
  buttonBig: {
    width: "100%",
    bordeRadius: "2px",
    height: "40px",
    margin: "0px"
  },
  buttonSmallText: {
    fontSize: "14px",
    color: "white",
    lineHeight: "20px"
  },
  buttonBigText: {
    fontSize: "15px",
    color: "white",
    lineHeight: "20px"
  },
  containerMobileButton: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    height: "60px",
    padding: "10px",
    backgroundColor: "#eeeeee"
  },
  notifications: {
    zIndex: "4",
    fontSize: "11px",
    paddingTop: "1px",
    marginRight: "2px",
    // border: "1px solid " + whiteColor,
    background: "rgba(0,0,0,0.2)",
    color: whiteColor,
    width: "20px",
    height: "20px",
    lineHeight: "20px",
    borderRadius: "10px",
    textAlign: "center",
    display: "inline-block"
  },
  transparentStyle: {
    backgroundColor: "transparent",
    paddingTop: "20px"
  },
  eventListContainer:{
    backgroundColor: "transarent",
    minHeight:'100vh',
    display:'flex',
  },
  museumContainer: {
/*    backgroundColor: "black",
    paddingTop: "20px",
    minHeight:'100vh'*/
  },
  containerMobileButtonMenu: {
    backgroundColor: "#eeeeee"
  },
  // SWEET ALERT FOR INGREDIENTS
  buttonAlert: {
    ...primaryBoxShadow,
    fontSize: "15px !important",
    color: "white !important",
    lineHeight: "20px !important",
    borderRadius: "30px !important",
    backgroundColor: `${grayColor[0]}`,
    height: "30px !important",
    border: "none !important",
    padding: "0px 18px !important",
    marginBottom: "10px !important",
    [theme.breakpoints.up("md")]: {
      minWidth: "100px !important",
      paddingLeft: "25px !important",
      paddingRight: "25px !important"
    }
  },
  totalButton: {
    backgroundColor: `${warningColor[0]}`
  },
  imageAlert: {
    // height: "120px",
    maxHeight: "200px",
    width: "100%",
    objectFit: "scale-down",
    [theme.breakpoints.down("md")]: {
      maxHeight: "130px"
    }
  },
  containerAlert: {
    display: "block",
    marginTop: "0px",
    top: "10%",
    padding: 0,
    zIndex: 500,
    backgroundColor: "red",
    fontSize: 0, // h2 title remove,
    [theme.breakpoints.up("md")]: {
      top: "20%"
    }
  },
  containerAlertBody: {
    overflowY: "auto",
    maxHeight: "calc(50vh - 100px)",
    width: "100%",
    fontSize: "15px",
    padding: "15px",
    paddingBottom: "0px",
    lineHeight: "normal",
    [theme.breakpoints.down("md")]: {
      maxHeight: "calc(50vh)"
    }
  },
  l: {
    lineHeight: "normal"
  },
  titleAdd: {
    minHeight: "40px",
    width: "90%",
    textAlign: "left",
    fontSize: "16px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: "rgba(74,74,74,1)"
  },
  descriptionAdd: {
    fontSize: "12px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: "#ccc"
  },
  detailTitleAdd: {
    minHeight: "40px",
    fontSize: "16px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: "rgba(74,74,74,1)",
    borderBottom: "solid 1px #cbcbcb",
    borderTop: "solid 1px #cbcbcb",
    lineHeight: "40px",
    textAlign: "center",
    width: "100%",
    backgroundColor: "#f0f0f0"
  },
  dayWrapper: {}
});

export default menuStyle;
